module.exports = __webpack_public_path__ + "img/uncheck.9229325b.svg";